import styled from 'helpers/styles';
import PropTypes from 'prop-types';
import ComponentStyles from 'styles/mixins/Component.styles';
import Box from 'components/atoms/Layout/Box/Box';
import {rgba} from 'polished';
import utils from 'helpers/utils';

const StyledBrowser = styled(Box)
  .attrs((props) => {
    let attr = props;

    const vars = {
      '--browser-background-color': rgba(props.theme.property(`palette.${props.$color}`)?.main, 0.02)
    };

    return utils.styleProps(attr, vars);
  })`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  height: 100%;
  min-height: inherit;

  background-color: ${props => props.$css.$var('--browser-background-color')};

  .Browser {
    &-controls {
      display: flex;
      .H6 {
        flex-grow: 1;
      }  
    }
    
    &-frame {
      flex-grow: 1;
      z-index: 1;

      overflow-x: hidden;
      overflow-y: auto;
    }
    
    &-screenshots {
      .ImageListItem {
        width: 100%;
        overflow-x: hidden;
        flex-direction: column-reverse;
        
        .ImageListItemBar {
          color: ${props => props.theme.property('palette.white.main')};
          background: linear-gradient(to bottom, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.4) 70%, rgba(0, 0, 0, 0.3) 100%);
          background-color: ${props => props.theme.property('palette.white.main')};

          column-gap: ${props => props.theme.layout('0.5sp')};
          
          > *:has(.MuiImageListItemBar-title) {
            padding-bottom: ${props => props.theme.spacing(0.75)};
          }
          
          .IconButton {
            margin-left: ${props => props.theme.spacing(0.25)};
            margin-top: ${props => props.theme.spacing(0.25)};
          }
        }
      }
    }
    
    &-center {
      position: absolute;
      height: 100%;
      width: 100%;
      
      display: flex;
      justify-content: center;
      align-items: center;
      pointer-events: none;
      > * {
        pointer-events: all;
      }
    }
  }
  
  ${ComponentStyles}
`;

StyledBrowser.propTypes = {
  theme: PropTypes.object
};

export default StyledBrowser;
